import { IInitObject, ITrackingEvent } from '../models';

export const lerp = (min, max, amount, minDiff = 0.0001) => {
    const diff = max - min;
    if (Math.abs(diff) < minDiff) return max;
    return min + diff * amount;
};

export const messageIsEvent = (data: unknown): data is ITrackingEvent => {
    return (
        !isUndefined(data) &&
        isObject(data) &&
        !isUndefined((data as ITrackingEvent).type) &&
        isString((data as ITrackingEvent).type) &&
        !isUndefined((data as ITrackingEvent).data)
    );
};

export const dataIsInitObject = (data: unknown): data is IInitObject => {
    return (
        !isUndefined(data) &&
        isObject(data) &&
        !isUndefined((data as IInitObject).clickStreamURL) &&
        isString((data as IInitObject).clickStreamURL) &&
        !isUndefined((data as IInitObject).appID) &&
        isString((data as IInitObject).appID) &&
        !isUndefined((data as IInitObject).productPackageID)
    );
};

export const isUndefined = (data: unknown): data is undefined => {
    return !(data != null);
};

export const isObject = (data: unknown): data is object => {
    return typeof data === 'object';
};

export const isString = (data: unknown): data is string => {
    return typeof data === 'string';
};
